import a1 from '../../../../image/settingsView/arrows/Default/1.png'
import a2 from '../../../../image/settingsView/arrows/Default/2.png'
import a3 from '../../../../image/settingsView/arrows/Default/3.png'
import a4 from '../../../../image/settingsView/arrows/Default/4.png'
import a5 from '../../../../image/settingsView/arrows/Default/5.png'
import a6 from '../../../../image/settingsView/arrows/Default/6.png'
import a7 from '../../../../image/settingsView/arrows/Default/7.png'
import a8 from '../../../../image/settingsView/arrows/Default/8.png'
import a9 from '../../../../image/settingsView/arrows/Default/9.png'
import a10 from '../../../../image/settingsView/arrows/Default/10.png'
import a11 from '../../../../image/settingsView/arrows/Default/11.png'
import a12 from '../../../../image/settingsView/arrows/Default/12.png'
import a13 from '../../../../image/settingsView/arrows/Default/13.png'
import a14 from '../../../../image/settingsView/arrows/Default/14.png'
import a15 from '../../../../image/settingsView/arrows/Default/15.png'
import a16 from '../../../../image/settingsView/arrows/Default/16.png'
import a17 from '../../../../image/settingsView/arrows/Default/17.png'
import a18 from '../../../../image/settingsView/arrows/Default/18.png'
import a19 from '../../../../image/settingsView/arrows/Default/19.png'
import a20 from '../../../../image/settingsView/arrows/Default/20.png'
import a21 from '../../../../image/settingsView/arrows/Default/21.png'
import a22 from '../../../../image/settingsView/arrows/Default/22.png'
import a23 from '../../../../image/settingsView/arrows/Default/23.png'
import a24 from '../../../../image/settingsView/arrows/Default/24.png'
import a25 from '../../../../image/settingsView/arrows/Default/25.png'
import a26 from '../../../../image/settingsView/arrows/Default/26.png'
import a27 from '../../../../image/settingsView/arrows/Default/27.png'
import a28 from '../../../../image/settingsView/arrows/Default/28.png'
import a29 from '../../../../image/settingsView/arrows/Default/29.png'
import a30 from '../../../../image/settingsView/arrows/Default/30.png'
import a31 from '../../../../image/settingsView/arrows/Default/31.png'
import a32 from '../../../../image/settingsView/arrows/Default/32.png'
import a33 from '../../../../image/settingsView/arrows/Default/33.png'
import a34 from '../../../../image/settingsView/arrows/Default/34.png'

// const DefaultArrowsList = [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11,
//     a12, a13, a14, a15, a16, a17, a18, a19, a20, a21, a22, a23, a24,
//     a25, a26, a27, a28, a29, a30, a31, a32, a33, a34]

// const DefaultArrowsList = [a1, a2, a3, a4, a5, a6, a7, a8, a8, a9, a10, a11,
//     a12, a13, a16, a17, a15, a14, a18, a19, a20, a21, a22, a23, a24,
//     a25, a26, a27, a28, a29, a30, a31, a34, a32, a33]

const DefaultArrowsList = [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11,
    a12, a13, a16, a17, a15, a14, a18, a19, a20, a21, a22, a23, a24,
    a25, a26, a27, a28, a29, a30, a31, a34, a32, a33]

export const vectorArrowsArray = [
    {
        id: 'cornered-1',
        path: ['M21.4 61L14 53.5L36.2 31L14 8.5L21.4 1L51 31L21.4 61Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'cornered-2',
        path: ['M19.4254 1L14 6.5041L38.1455 31.0039L14 55.4959L19.4254 61L49 31.0039L19.4254 1Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'cornered-3',
        path: ['M20.17 1L16 5.21729L40.783 31.0396L38.14 33.7935L38.155 33.7773L16.135 56.7197L20.242 61C26.329 54.661 43.321 36.9585 49 31.0396C44.782 26.6416 48.895 30.928 20.17 1Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'cornered-4',
        path: ['M18.8947 1L16 3.88025L43.2107 30.998L16 58.1116L18.8947 61L49 30.998L18.8947 1Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'rounded-1',
        path: ['M17.9737 60.0263C19.2721 61.3246 21.3771 61.3246 22.6754 60.0263L44.7652 37.9363C48.6593 34.0422 48.6603 27.7295 44.7679 23.834L22.9245 1.97376C21.6262 0.675415 19.5212 0.675415 18.2229 1.97376C16.9246 3.27206 16.9246 5.37708 18.2229 6.67538L40.072 28.5244C41.3705 29.823 41.3705 31.9278 40.072 33.226L17.9737 55.3244C16.6754 56.623 16.6754 58.7277 17.9737 60.0263Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'rounded-2',
        path: ['M16.0975 60.1231C17.3123 61.2923 19.2789 61.2923 20.4905 60.1231L46.1803 35.3334C48.6067 32.992 48.6067 29.1934 46.1803 26.852L20.3041 1.87778C19.1018 0.720531 17.1601 0.704769 15.9422 1.84702C14.6995 3.01325 14.684 4.93576 15.9081 6.11998L39.5908 28.9716C40.8056 30.1438 40.8056 32.0416 39.5908 33.2138L16.0975 55.8838C14.8828 57.053 14.8828 58.9538 16.0975 60.1231Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'rounded-3',
        path: ['M19.0075 61C18.4989 61 17.9772 60.7992 17.5869 60.407C16.8044 59.6245 16.8044 58.3465 17.5869 57.5639L44.3434 30.7962L17.9772 4.42995C17.1947 3.64741 17.1947 2.36945 17.9772 1.58691C18.7598 0.804365 20.0377 0.804365 20.8203 1.58691L48.6071 29.3737C49.3896 30.1562 49.3896 31.4342 48.6071 32.2167L20.43 60.407C20.0396 60.7973 19.516 61 19.0075 61Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'arrow',
        path: ['M36.0389 8.75315C37.0431 7.74895 38.6712 7.74895 39.6754 8.75315L60.2468 29.3246C61.2511 30.3288 61.2511 31.9569 60.2468 32.9611L39.6754 53.5326C38.6712 54.5368 37.0431 54.5368 36.0389 53.5326C35.0347 52.5284 35.0347 50.9002 36.0389 49.896L52.2206 33.7143H3.57143C2.15127 33.7143 1 32.563 1 31.1429C1 29.7227 2.15127 28.5714 3.57143 28.5714H52.2206L36.0389 12.3897C35.0347 11.3855 35.0347 9.75736 36.0389 8.75315Z'],
        viewbox: '0 0 62 62'
    }, {
        id: 'squared-1',
        path: [
            'M2.875 2.875H59.125V59.125H2.875V2.875ZM61 1V61H0.999996V1H61Z',
            'M27.12 40.7508C26.9362 40.9345 26.6962 41.0245 26.4562 41.0245C26.2162 41.0245 25.9762 40.9327 25.7925 40.7508C25.4269 40.3852 25.4269 39.7908 25.7925 39.4252L34.2169 31.0008L25.7944 22.5764C25.4288 22.2108 25.4288 21.6164 25.7944 21.2508C26.16 20.8852 26.7544 20.8852 27.12 21.2508L36.2063 30.337C36.5719 30.7027 36.5719 31.297 36.2063 31.6627L27.12 40.7508Z'
        ],
        viewbox: '0 0 62 62',
        fillRule: 'stroke',
        strokeWidth: 2
    }, {
        id: 'squared-2',
        path: [
            'M2.875 2.875H59.125V59.125H2.875V2.875ZM61 1V61H0.999996V1H61Z',
            'M27.12 40.7508C26.9362 40.9345 26.6962 41.0245 26.4562 41.0245C26.2162 41.0245 25.9762 40.9327 25.7925 40.7508C25.4269 40.3852 25.4269 39.7908 25.7925 39.4252L34.2169 31.0008L25.7944 22.5764C25.4288 22.2108 25.4288 21.6164 25.7944 21.2508C26.16 20.8852 26.7544 20.8852 27.12 21.2508L36.2063 30.337C36.5719 30.7027 36.5719 31.297 36.2063 31.6627L27.12 40.7508Z'
        ],
        viewbox: '0 0 62 62',
        fillRule: 'stroke',
        strokeWidth: 4
    }, {
        id: 'squared-3',
        path: [
            'M2.875 2.875H59.125V59.125H2.875V2.875ZM61 1V61H0.999996V1H61Z',
            'M27.12 40.7508C26.9362 40.9345 26.6962 41.0245 26.4562 41.0245C26.2162 41.0245 25.9762 40.9327 25.7925 40.7508C25.4269 40.3852 25.4269 39.7908 25.7925 39.4252L34.2169 31.0008L25.7944 22.5764C25.4288 22.2108 25.4288 21.6164 25.7944 21.2508C26.16 20.8852 26.7544 20.8852 27.12 21.2508L36.2063 30.337C36.5719 30.7027 36.5719 31.297 36.2063 31.6627L27.12 40.7508Z'
        ],
        viewbox: '0 0 62 62',
        fillRule: 'stroke',
        strokeWidth: 6
    }, {
        id: 'squared-4',
        path: [
            'M56.391 0C58.3842 0 60 1.61582 60 3.60902V56.391C60 58.3842 58.3842 60 56.391 60H3.60902C1.61582 60 0 58.3842 0 56.391V3.60902C0 1.61581 1.61582 0 3.60902 0H56.391ZM24.5704 20.9935C23.6896 20.1126 23.6896 18.6844 24.5704 17.8035C25.4513 16.9226 26.8795 16.9226 27.7604 17.8035L38.407 28.4501C39.2879 29.331 39.2879 30.7592 38.407 31.6401L27.7604 42.2867C26.8795 43.1676 25.4513 43.1676 24.5704 42.2867C23.6896 41.4058 23.6896 39.9776 24.5704 39.0968L33.6221 30.0451L24.5704 20.9935Z'
        ],
        fillRule: 'evenodd',
        viewbox: '0 0 62 62'
    }, {
        id: 'circle-1',
        path: [
            'M31 61C47.5412 61 61 47.5412 61 31C61 14.4588 47.5412 1 31 1C14.4588 1 1 14.4588 1 31C1 47.5412 14.4588 61 31 61ZM31 2.875C46.5081 2.875 59.125 15.4919 59.125 31C59.125 46.5081 46.5081 59.125 31 59.125C15.4919 59.125 2.875 46.5081 2.875 31C2.875 15.4919 15.4919 2.875 31 2.875Z',
            'M25.7952 40.7508C25.9789 40.9345 26.2189 41.0245 26.4589 41.0245C26.6989 41.0245 26.9389 40.9327 27.1227 40.7508L36.2089 31.6645C36.5745 31.2989 36.5745 30.7045 36.2089 30.3389L27.1208 21.2508C26.7552 20.8852 26.1608 20.8852 25.7952 21.2508C25.4295 21.6164 25.4295 22.2108 25.7952 22.5764L34.2177 31.0008L25.7952 39.4252C25.4277 39.7908 25.4277 40.3833 25.7952 40.7508Z'
        ],
        viewbox: '0 0 62 62',
        fillRule: 'stroke',
        strokeWidth: 2
    }, {
        id: 'circle-2',
        path: [
            'M31 61C47.5412 61 61 47.5412 61 31C61 14.4588 47.5412 1 31 1C14.4588 1 1 14.4588 1 31C1 47.5412 14.4588 61 31 61ZM31 2.875C46.5081 2.875 59.125 15.4919 59.125 31C59.125 46.5081 46.5081 59.125 31 59.125C15.4919 59.125 2.875 46.5081 2.875 31C2.875 15.4919 15.4919 2.875 31 2.875Z',
            'M25.7952 40.7508C25.9789 40.9345 26.2189 41.0245 26.4589 41.0245C26.6989 41.0245 26.9389 40.9327 27.1227 40.7508L36.2089 31.6645C36.5745 31.2989 36.5745 30.7045 36.2089 30.3389L27.1208 21.2508C26.7552 20.8852 26.1608 20.8852 25.7952 21.2508C25.4295 21.6164 25.4295 22.2108 25.7952 22.5764L34.2177 31.0008L25.7952 39.4252C25.4277 39.7908 25.4277 40.3833 25.7952 40.7508Z'
        ],
        viewbox: '-2 -2 66 66',
        fillRule: 'stroke',
        strokeWidth: 4
    }, {
        id: 'circle-3',
        path: [
            'M31 61C47.5412 61 61 47.5412 61 31C61 14.4588 47.5412 1 31 1C14.4588 1 1 14.4588 1 31C1 47.5412 14.4588 61 31 61ZM31 2.875C46.5081 2.875 59.125 15.4919 59.125 31C59.125 46.5081 46.5081 59.125 31 59.125C15.4919 59.125 2.875 46.5081 2.875 31C2.875 15.4919 15.4919 2.875 31 2.875Z',
            'M25.7952 40.7508C25.9789 40.9345 26.2189 41.0245 26.4589 41.0245C26.6989 41.0245 26.9389 40.9327 27.1227 40.7508L36.2089 31.6645C36.5745 31.2989 36.5745 30.7045 36.2089 30.3389L27.1208 21.2508C26.7552 20.8852 26.1608 20.8852 25.7952 21.2508C25.4295 21.6164 25.4295 22.2108 25.7952 22.5764L34.2177 31.0008L25.7952 39.4252C25.4277 39.7908 25.4277 40.3833 25.7952 40.7508Z'
        ],
        viewbox: '-6 -6 74 74',
        fillRule: 'stroke',
        strokeWidth: 8
    }, {
        id: 'circle-4',
        path: [
            'M31 1C14.47 1 1 14.47 1 31C1 47.53 14.47 61 31 61C47.53 61 61 47.53 61 31C61 14.47 47.53 1 31 1ZM39.37 32.59L28.78 43.18C28.33 43.63 27.76 43.84 27.19 43.84C26.62 43.84 26.05 43.63 25.6 43.18C24.73 42.31 24.73 40.87 25.6 40L34.6 31L25.6 22C24.73 21.13 24.73 19.69 25.6 18.82C26.47 17.95 27.91 17.95 28.78 18.82L39.37 29.41C40.27 30.28 40.27 31.72 39.37 32.59Z'
        ],
        viewbox: '0 0 62 62'
    },
]


export { DefaultArrowsList }